import { IModelDataV1, Model } from '@df/catalog/model';

export interface ICustomformData extends IModelDataV1 {
    url: string;
    fields: ICustomformField[];
    submit_button_text?: string;
    success_message?: string;
    title?: string;
    redirect_link?: string;
}

export interface ICustomformField {
    cid: string;
    field_type: string;
    fieldcol: number;
    label: string;
    required?: boolean;
    placeholder?: string;
    show_address?: 1 | 2;
    show_city?: 1 | 2;
    show_country?: 1 | 2;
    show_state?: 1 | 2;
    show_zipcode?: 1 | 2;
    image_type?: string;
    image_maximum_size?: number;
    wrappercol: number;
    field_options?: {
        include_blank_option?: boolean;
        include_other_option?: boolean;
        options?: {
            checked: boolean;
            label: string;
            value?: string;
        }[];
        description?: string;
        maxlength?: number;
        minlength?: number;
    };
}

/**
 * Custom form model representing form data from LOC Form Builder
 */
export class Customform extends Model<ICustomformData, number> {
    /**
     * Object type id
     * @type {String}
     */
    static override type = 'customform';

    /**
     * Retrieves field by its title (regex matchin is used)
     * @author Maurycy Ornat maurycy@tomandco.co.uk
     * @param  {string | RegExp} name
     */
    getField(name: string | RegExp): ICustomformField | undefined {
        if (!name) {
            return undefined;
        }
        const reg = typeof name === 'string' ? new RegExp(name, 'i') : name;
        return this.data?.fields.find(field => !!(field.label && field.label.match(reg)));
    }
}
